/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Todo_ReasonInputs */

const en_todo_reason = /** @type {(inputs: Todo_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Todo_ReasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const todo_reason = /** @type {((inputs?: Todo_ReasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Todo_ReasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_todo_reason(inputs)
});